import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ReportsService } from '../../../../core/services/reports.service';
import { simpleFormatDate } from 'src/app/reports/utils';

@Injectable({
  providedIn: 'root'
})
export class SessionSummaryResolver  {
  constructor(
    private reportsService: ReportsService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    const now = new Date(Date.now());
    const today = simpleFormatDate(now.getFullYear(), now.getMonth() + 1, now.getDate())

    // On load, we start with sessions just for the current date
    return this.reportsService.getSessionSummaryData([ today, today ]) ;
  }
}
